function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
      v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

angular.module('bizmetryApp').controller('EditTemplateDialogController', function (
  $scope, $mdDialog, $mdToast, $http, $timeout, $q, CONFIG, templateInstance, TemplateInstanceService, profile, dialogService,
  DatasourceService, ApiCollectionService, ApiCollectionTree, ApiCollectionViewer
) {

  // ============================================
  // INICIALIZACIÓN
  // ============================================

  $scope.editedTemplate = angular.copy(templateInstance);
  $scope.templateInstance = templateInstance;
  $scope.profile = profile;
  $scope.saving = false;

  $scope.clients = $scope.editedTemplate.templateConfig.client_types || [];
  $scope.resources = $scope.editedTemplate.templateConfig.resource_types || [];
  $scope.attributes = $scope.editedTemplate.templateConfig.attribute_types || [];
  $scope.resource_owners = $scope.editedTemplate.templateConfig.resource_owners || [];
  $scope.frames = $scope.editedTemplate.templateConfig.frame_types || [];

  $scope.originalClients = angular.copy($scope.clients);
  $scope.originalResources = angular.copy($scope.resources);
  $scope.originalAttributes = angular.copy($scope.attributes);
  $scope.originalResourceOwners = angular.copy($scope.resource_owners);
  $scope.originalFrames = angular.copy($scope.frames);

  // ============================================
  // SORT + SEARCH STATE
  // ============================================

  $scope.clientSortOrder = 'asc';
  $scope.resourceSortOrder = 'asc';
  $scope.ownerSortOrder = 'asc';
  $scope.frameSortOrder = 'asc';

  $scope.clientSearch = '';
  $scope.resourceSearch = '';
  $scope.ownerSearch = '';
  $scope.frameSearch = '';

  // Sorted + filtered arrays que consume el HTML
  $scope.filteredClients = [];
  $scope.filteredResources = [];
  $scope.filteredOwners = [];
  $scope.filteredFrames = [];

  // ============================================
  // HELPER: filtrado + ordenado en un paso
  // ============================================

  function applyFilterAndSort(sourceArray, searchTerm, sortOrder, nameField, descField) {
    var term = (searchTerm || '').toLowerCase().trim();
    var df = descField || 'description';

    var result = term
      ? sourceArray.filter(function (item) {
        var matchName = (item[nameField] || '').toLowerCase().indexOf(term) !== -1;
        var matchDesc = (item[df] || '').toLowerCase().indexOf(term) !== -1;
        return matchName || matchDesc;
      })
      : sourceArray.slice();

    result.sort(function (a, b) {
      var nameA = (a[nameField] || '').toUpperCase();
      var nameB = (b[nameField] || '').toUpperCase();
      return sortOrder === 'asc' ? nameA.localeCompare(nameB) : nameB.localeCompare(nameA);
    });

    return result;
  }

  // ============================================
  // SORT + FILTER — Client Types
  // ============================================

  $scope.sortClientsBySortOrder = function () {
    $scope.filteredClients = applyFilterAndSort(
      $scope.clients, $scope.clientSearch, $scope.clientSortOrder, 'name'
    );
  };

  $scope.applyClientFilter = function () {
    $scope.sortClientsBySortOrder();
  };

  // ============================================
  // SORT + FILTER — Resource Types
  // ============================================

  $scope.sortResourcesBySortOrder = function () {
    $scope.filteredResources = applyFilterAndSort(
      $scope.resources, $scope.resourceSearch, $scope.resourceSortOrder, 'name'
    );
  };

  $scope.applyResourceFilter = function () {
    $scope.sortResourcesBySortOrder();
  };

  // ============================================
  // SORT + FILTER — Resource Domains
  // ============================================

  $scope.sortOwnersBySortOrder = function () {
    $scope.filteredOwners = applyFilterAndSort(
      $scope.resource_owners, $scope.ownerSearch, $scope.ownerSortOrder, 'name'
    );
  };

  $scope.applyOwnerFilter = function () {
    $scope.sortOwnersBySortOrder();
  };

  // ============================================
  // SORT + FILTER — Frame Types
  // ============================================

  $scope.sortFrames = function () {
    $scope.filteredFrames = applyFilterAndSort(
      $scope.frames, $scope.frameSearch, $scope.frameSortOrder, 'frame_name', 'frame_description'
    );
  };

  $scope.applyFrameFilter = function () {
    $scope.sortFrames();
  };

  // ============================================
  // CLEAR SEARCH
  // ============================================

  $scope.clearSearch = function (type) {
    switch (type) {
      case 'client': $scope.clientSearch = ''; $scope.sortClientsBySortOrder(); break;
      case 'resource': $scope.resourceSearch = ''; $scope.sortResourcesBySortOrder(); break;
      case 'owner': $scope.ownerSearch = ''; $scope.sortOwnersBySortOrder(); break;
      case 'frame': $scope.frameSearch = ''; $scope.sortFrames(); break;
    }
  };

  // Inicializar todos los filtered arrays al arrancar
  $scope.sortClientsBySortOrder();
  $scope.sortResourcesBySortOrder();
  $scope.sortOwnersBySortOrder();
  $scope.sortFrames();

  // ============================================
  // RECONSTRUCT resource_owner objects
  // ============================================

  $scope.reconstructResourceOwners = function () {
    if (!$scope.resources || !$scope.resource_owners) {
      console.warn('⚠️ Cannot reconstruct resource_owners: missing data');
      return;
    }

    var reconstructedCount = 0;

    $scope.resources.forEach(function (resource) {
      if (!resource.resource_owner ||
        typeof resource.resource_owner === 'string' ||
        typeof resource.resource_owner === 'number') {

        var ownerId = resource.resource_owner || resource.resource_owner_id || resource.domain_id;
        if (ownerId) {
          var ownerObj = $scope.resource_owners.find(function (o) { return o.id === ownerId; });
          if (ownerObj) {
            resource.resource_owner = ownerObj;
            reconstructedCount++;
          }
        }
      } else if (resource.resource_owner && !resource.resource_owner.name) {
        var ownerObj = $scope.resource_owners.find(function (o) { return o.id === resource.resource_owner.id; });
        if (ownerObj) {
          resource.resource_owner = ownerObj;
          reconstructedCount++;
        }
      }
    });

    if (reconstructedCount > 0) {
      console.log('✅ Total resource_owners reconstructed:', reconstructedCount);
    }
  };

  $scope.reconstructResourceOwners();

  // ============================================
  // CHANGE DETECTION
  // ============================================

  $scope.hasClientsChanged = function () { return !angular.equals($scope.clients, $scope.originalClients); };
  $scope.hasResourcesChanged = function () { return !angular.equals($scope.resources, $scope.originalResources); };
  $scope.hasAttributesChanged = function () { return !angular.equals($scope.attributes, $scope.originalAttributes); };
  $scope.hasResourceOwnersChanged = function () { return !angular.equals($scope.resource_owners, $scope.originalResourceOwners); };
  $scope.hasFramesChanged = function () { return !angular.equals($scope.frames, $scope.originalFrames); };

  $scope.hasAnyChanged = function () {
    return $scope.hasClientsChanged() ||
      $scope.hasResourcesChanged() ||
      $scope.hasAttributesChanged() ||
      $scope.hasResourceOwnersChanged() ||
      $scope.hasFramesChanged() ||
      $scope.hasApiCollectionsChanged();
  };

  // ============================================
  // API COLLECTIONS — versions this template exposes to its biz events
  // ============================================
  // One version per collection family; staged like every other tab and
  // applied on Save to the version the save produces (a PUBLISHED template
  // forks into a DRAFT that inherits its associations). Publishing the
  // template requires all of them to be PUBLISHED.

  $scope.apiCollections = [];           // staged: { collection_id, collection_name, api_version, status, description }
  $scope.originalApiCollections = [];
  $scope.apiCollectionFamilies = {};    // collection_name → selectable versions, newest first
  $scope.apiCollectionsLoading = true;
  $scope.apiCollectionsError = null;
  $scope.newApiCollection = { family: null, collectionId: null };

  function _toApiCollectionRow(c) {
    return {
      collection_id: c.collection_id, collection_name: c.collection_name,
      api_version: c.api_version, status: c.status, description: c.description
    };
  }

  // Every non-RETIRED collection version, grouped by family (collection_name).
  function _loadApiCollectionCatalog() {
    return ApiCollectionService.getAll(null, { page: 0, size: 1000, sortField: 'collection_name', sortDir: 'ASC', includeReferences: false })
      .then(function (response) {
        var all = (response.status === 204 ? [] : (response.data && response.data.content) || [])
          .filter(function (c) { return c.status !== 'RETIRED'; });
        var families = {};
        all.forEach(function (c) { (families[c.collection_name] = families[c.collection_name] || []).push(c); });
        Object.keys(families).forEach(function (name) {
          families[name].sort(function (a, b) { return ApiCollectionTree.compareVersions(b, a); });
        });
        $scope.apiCollectionFamilies = families;
      });
  }

  $q.all([
    TemplateInstanceService.getApiCollections($scope.editedTemplate.id, { skipLoader: true }),
    _loadApiCollectionCatalog()
  ]).then(function (res) {
    var associated = (res[0].data && res[0].data.api_collections) || [];
    // Which biz events a change of that collection family will recompute (tooltips).
    associated.forEach(function (c) {
      _savedLinkUsage[c.collection_name] = { refs: c.referenced_by || [], checked: c.references_checked !== false };
    });
    $scope.apiCollections = associated.map(_toApiCollectionRow);
    $scope.originalApiCollections = angular.copy($scope.apiCollections);
  }).catch(function (err) {
    $scope.apiCollectionsError = (err && err.data && err.data.message) || 'Could not load API collections.';
  }).finally(function () {
    $scope.apiCollectionsLoading = false;
  });

  $scope.hasApiCollectionsChanged = function () {
    var ids = function (list) { return list.map(function (c) { return c.collection_id; }).sort().join(','); };
    return ids($scope.apiCollections) !== ids($scope.originalApiCollections);
  };

  // Families not associated yet — candidates for "Add".
  $scope.availableApiCollectionFamilies = function () {
    var used = {};
    $scope.apiCollections.forEach(function (c) { used[c.collection_name] = true; });
    return Object.keys($scope.apiCollectionFamilies).filter(function (n) { return !used[n]; }).sort();
  };

  $scope.apiCollectionVersions = function (family) {
    return $scope.apiCollectionFamilies[family] || [];
  };

  $scope.onNewApiCollectionFamily = function () {
    var versions = $scope.apiCollectionVersions($scope.newApiCollection.family);
    $scope.newApiCollection.collectionId = versions.length ? versions[0].collection_id : null;
  };

  $scope.addApiCollection = function () {
    var version = $scope.apiCollectionVersions($scope.newApiCollection.family).find(function (c) {
      return c.collection_id === $scope.newApiCollection.collectionId;
    });
    if (!version) { return; }
    $scope.apiCollections.push(_toApiCollectionRow(version));
    $scope.newApiCollection = { family: null, collectionId: null };
  };

  // Details of a collection version (a linked row, or the one picked in the "Add"
  // selects); it can be edited from there. Saving a PUBLISHED version forks a new
  // DRAFT, so the catalog is reloaded to offer it, and the staged rows pick up the
  // edited name/description/status. Links themselves are left untouched.
  $scope.viewApiCollection = function (collectionId) {
    if (!collectionId) { return; }
    ApiCollectionViewer.openDetails(collectionId, { allowEdit: true }).then(function (result) {
      if (!result) { return; }
      _loadApiCollectionCatalog().then(function () {
        var byId = {};
        Object.keys($scope.apiCollectionFamilies).forEach(function (name) {
          $scope.apiCollectionFamilies[name].forEach(function (c) { byId[c.collection_id] = c; });
        });
        $scope.apiCollections.forEach(function (row) {
          if (byId[row.collection_id]) { angular.extend(row, _toApiCollectionRow(byId[row.collection_id])); }
        });
      });
    });
  };

  // Switching the version of an associated collection (same family).
  $scope.changeApiCollectionVersion = function (row) {
    var version = $scope.apiCollectionVersions(row.collection_name).find(function (c) {
      return c.collection_id === row.collection_id;
    });
    if (version) { angular.extend(row, _toApiCollectionRow(version)); }
  };

  var _savedLinkUsage = {};   // collection_name → { refs, checked } of the saved link

  // Unlinking or switching the version is always allowed. On save, the template's
  // non-published biz events follow the change: sources moved to the new version (or
  // dropped with the collection), mappings reconciled, IntelliSense re-run, back to
  // DRAFT with a recompute summary in their Status column. On a PUBLISHED template the
  // change lands on the new version, and the biz events forked onto it are recomputed.
  function _recomputeHint(row) {
    if (_savesAsNewVersion()) {
      return 'Biz events forked onto the new template version will be recomputed.';
    }
    var usage = _savedLinkUsage[row.collection_name];
    if (!usage || !usage.checked || !usage.refs.length) { return ''; }
    return 'Biz events ' + usage.refs.map(function (r) { return r.name + ' v' + r.version; }).join(', ') +
      ' will be recomputed with IntelliSense and go back to DRAFT.';
  }

  function _savesAsNewVersion() {
    var t = $scope.editedTemplate || {};
    return (t.templateStatus || t.status) === 'PUBLISHED';
  }

  $scope.apiCollectionUnlinkTooltip = function (row) {
    var hint = _recomputeHint(row);
    return 'Remove from this template' + (hint ? ' — ' + hint : '');
  };

  $scope.apiCollectionVersionTooltip = function (row) {
    return _recomputeHint(row);
  };

  $scope.removeApiCollection = function (row) {
    $scope.apiCollections = $scope.apiCollections.filter(function (c) { return c !== row; });
  };

  $scope.apiCollectionPublishBlockers = function () {
    return $scope.apiCollections.filter(function (c) { return c.status !== 'PUBLISHED'; });
  };

  // Applies the staged associations to the saved template version: removed
  // families are dissociated, new or re-versioned ones associated (replace).
  function _applyApiCollectionChanges(templateId) {
    if (!$scope.hasApiCollectionsChanged()) { return $q.when(); }
    var current = {}, original = {};
    $scope.apiCollections.forEach(function (c) { current[c.collection_name] = c.collection_id; });
    $scope.originalApiCollections.forEach(function (c) { original[c.collection_name] = c.collection_id; });

    var steps = [];
    Object.keys(original).forEach(function (family) {
      if (!current[family]) {
        steps.push(function () { return TemplateInstanceService.removeApiCollection(templateId, original[family]); });
      }
    });
    Object.keys(current).forEach(function (family) {
      if (current[family] !== original[family]) {
        steps.push(function () { return TemplateInstanceService.addApiCollection(templateId, current[family], true); });
      }
    });
    return steps.reduce(function (p, step) { return p.then(step); }, $q.when());
  }

  $scope.isSaveDisabled = function () {
    return !$scope.hasAnyChanged() ||
      $scope.clients.some(function (c) { return !c.name || !c.description; }) ||
      $scope.resources.some(function (r) { return !r.name || !r.description; }) ||
      $scope.resource_owners.some(function (r) { return !r.name || !r.description; }) ||
      $scope.frames.some(function (f) { return !f.frame_name || !f.frame_description; }) ||
      $scope.hasFrameNameConflict() ||
      $scope.saving;
  };

  // ============================================
  // CLOSE
  // ============================================

  $scope.close = function () {
    $scope.validationError = null;
    $scope.showValidationBanner = false;

    if ($scope.hasAnyChanged()) {
      dialogService.showDecisionDialog(
        'Discard Changes?',
        'You have unsaved changes. Are you sure you want to discard them?'
      ).then(function (decision) {
        if (decision === 'proceed') $mdDialog.hide();
      });
    } else {
      $mdDialog.hide();
    }
  };

  // ============================================
  // SAVE
  // ============================================

  $scope.save = function () {
    if ($scope.saving) return;
    $scope.saving = true;

    var filteredResources = $scope.resources.map(function (resource) {
      if (resource.scalar_attribute_type === 'OBJECT_REF') {
        return {
          id: resource.id, name: resource.name, enabled: resource.enabled,
          description: resource.description, resource_id: resource.resource_id,
          resourceType: { id: resource.resourceType.id, name: resource.resourceType.name }
        };
      }
      return resource;
    });

    var filteredTemplate = angular.copy($scope.editedTemplate);
    if (filteredTemplate.templateConfig) {
      filteredTemplate.templateConfig.client_types = $scope.clients;
      filteredTemplate.templateConfig.resource_types = filteredResources;
      filteredTemplate.templateConfig.attribute_types = $scope.attributes;
      filteredTemplate.templateConfig.resource_owners = $scope.resource_owners;
      filteredTemplate.templateConfig.frame_types = $scope.frames;
    }

    TemplateInstanceService.updateTemplateInstance(filteredTemplate.id, filteredTemplate)
      .then(function (response) {
        // The save may have produced a new version (PUBLISHED → DRAFT fork):
        // associations go to whichever version was saved.
        var savedId = (response && response.data && response.data.id) || filteredTemplate.id;
        return _applyApiCollectionChanges(savedId).then(function () { return response; });
      })
      .then(function (response) {
        $scope.saving = false;
        $mdToast.show($mdToast.simple().textContent('Template saved successfully').position('top right').hideDelay(2500));
        $mdDialog.hide(response);
      })
      .catch(function (error) {
        $scope.saving = false;
        var errorMessage = 'An error occurred while saving the template.';
        if (error.data) {
          if (typeof error.data === 'string' || (error.data.error && error.data.message)) {
            errorMessage = dialogService.formatErrorMessage(error.data);
          } else if (error.data.message) {
            errorMessage = error.data.message;
          }
        } else if (error.statusText) {
          errorMessage = error.statusText;
        }
        dialogService.showErrorDialog('Error Saving Template', errorMessage);
      });
  };

  // ============================================
  // CLIENT TYPES
  // ============================================

  $scope.selectedClientIndex = null;

  $scope.selectClient = function (index) {
    $scope.selectedClientIndex = index;
  };

  $scope.addClient = function () {
    var newClient = { id: uuidv4(), name: '', description: '', enabled: true };
    $scope.clients.push(newClient);
    $scope.sortClientsBySortOrder();

    // ✅ Buscar el item nuevo en el filteredArray (no usar el índice del source array)
    var newIdx = $scope.filteredClients.findIndex(function (c) { return c.id === newClient.id; });
    $scope.selectedClientIndex = newIdx;

    $timeout(function () {
      var activeRows = document.querySelectorAll(
        '.edit-template-dialog md-tab-content.md-active .types-table tbody tr'
      );
      if (activeRows && activeRows[newIdx]) {
        activeRows[newIdx].scrollIntoView({ behavior: 'smooth', block: 'center' });
        var input = activeRows[newIdx].querySelector('input');
        if (input) input.focus();
      }
    }, 100);
  };


  $scope.removeClient = function (clientId) {
    var idx = $scope.clients.findIndex(function (c) { return c.id === clientId; });
    if (idx === -1) return;
    $scope.clients.splice(idx, 1);
    $scope.selectedClientIndex = null;
    $scope.sortClientsBySortOrder();
  };

  $scope.moveClient = function (idx, dir) {
    var newIdx = idx + dir;
    if (newIdx >= 0 && newIdx < $scope.clients.length) {
      var temp = $scope.clients[idx];
      $scope.clients[idx] = $scope.clients[newIdx];
      $scope.clients[newIdx] = temp;
      $scope.selectedClientIndex = newIdx;
      $scope.sortClientsBySortOrder();
    }
  };

  // ============================================
  // RESOURCE TYPES
  // ============================================

  $scope.selectedResourceIndex = null;

  $scope.selectResource = function (index) {
    $scope.selectedResourceIndex = index;
  };

  $scope.addResource = function () {
    var newResource = { id: uuidv4(), name: '', description: '', enabled: true };
    $scope.resources.push(newResource);
    $scope.sortResourcesBySortOrder();

    // ✅ Buscar el item nuevo en el filteredArray
    var newIdx = $scope.filteredResources.findIndex(function (r) { return r.id === newResource.id; });
    $scope.selectedResourceIndex = newIdx;

    $timeout(function () {
      var activeRows = document.querySelectorAll(
        '.edit-template-dialog md-tab-content.md-active .types-table tbody tr'
      );
      if (activeRows && activeRows[newIdx]) {
        activeRows[newIdx].scrollIntoView({ behavior: 'smooth', block: 'center' });
        var input = activeRows[newIdx].querySelector('input');
        if (input) input.focus();
      }
    }, 100);
  };

  $scope.removeResource = function (resourceId) {
    var idx = $scope.resources.findIndex(function (r) { return r.id === resourceId; });
    if (idx === -1) return;
    var resourceToDelete = $scope.resources[idx];
    $scope.resources.splice(idx, 1);

    for (var i = $scope.attributes.length - 1; i >= 0; i--) {
      if ($scope.attributes[i].resource_id === resourceToDelete.id) {
        $scope.attributes.splice(i, 1);
      }
    }

    $scope.editedTemplate.templateConfig.attribute_types = $scope.attributes;
    $scope.selectedResourceIndex = null;
    $scope.sortResourcesBySortOrder();
  };


  $scope.moveResource = function (idx, dir) {
    var newIdx = idx + dir;
    if (newIdx >= 0 && newIdx < $scope.resources.length) {
      var temp = $scope.resources[idx];
      $scope.resources[idx] = $scope.resources[newIdx];
      $scope.resources[newIdx] = temp;
      $scope.selectedResourceIndex = newIdx;
      $scope.sortResourcesBySortOrder();
    }
  };

  // ============================================
  // EDIT ATTRIBUTES
  // ============================================

  $scope.editAttributes = function (resource, $event) {
    if ($event) $event.stopPropagation();

    console.log('$scope.attributes=', $scope.attributes);

    var attrs = ($scope.attributes || []).filter(function (attr) {
      return attr.resource_id === resource.id;
    });

    $mdDialog.show({
      controller: 'ResourceAttributesDialogController',
      templateUrl: 'template/attributeEdit/resource-attributes-dialog.html',
      parent: angular.element(document.body),
      clickOutsideToClose: true,
      escapeToClose: false,
      multiple: true,
      locals: { resource: resource, attributes: attrs, editedTemplate: $scope.editedTemplate }
    }).then(function (attrsEditados) {
      $scope.attributes = ($scope.attributes || [])
        .filter(function (attr) { return attr.resource_id !== resource.id; })
        .concat((attrsEditados || []).filter(function (a) { return a != null; }));

      $scope.editedTemplate.templateConfig.attribute_types = $scope.attributes;
    });
  };

  $scope.showResourceAttributes = $scope.editAttributes;

  // ============================================
  // RESOURCE DOMAINS
  // ============================================

  $scope.selectedOwnerIndex = null;

  $scope.selectOwner = function (index) {
    $scope.selectedOwnerIndex = index;
  };

  $scope.addOwner = function () {
    var newOwner = { id: uuidv4(), name: '', description: '', enabled: true };
    $scope.resource_owners.push(newOwner);
    $scope.sortOwnersBySortOrder();

    // ✅ Buscar el item nuevo en el filteredArray
    var newIdx = $scope.filteredOwners.findIndex(function (o) { return o.id === newOwner.id; });
    $scope.selectedOwnerIndex = newIdx;

    $timeout(function () {
      var activeRows = document.querySelectorAll(
        '.edit-template-dialog md-tab-content.md-active .types-table tbody tr'
      );
      if (activeRows && activeRows[newIdx]) {
        activeRows[newIdx].scrollIntoView({ behavior: 'smooth', block: 'center' });
        var input = activeRows[newIdx].querySelector('input');
        if (input) input.focus();
      }
    }, 100);
  };


  $scope.removeOwner = function (ownerId) {
    var idx = $scope.resource_owners.findIndex(function (o) { return o.id === ownerId; });
    if (idx === -1) return;
    $scope.resource_owners.splice(idx, 1);
    $scope.selectedOwnerIndex = null;
    $scope.sortOwnersBySortOrder();
  };

  // ============================================
  // HELPERS
  // ============================================

  $scope.isReferencedByAttribute = function (resource) {
    if (!resource || !resource.id) return false;

    var frameTypes = $scope.frames;

    if (!frameTypes || !frameTypes.length) return false;

    return frameTypes.some(function (frameType) {
      if (!frameType.frame_fields || !frameType.frame_fields.length) return false;

      return frameType.frame_fields.some(function (field) {

        // OBJECT_REFERENCE, FIELD_REFERENCE y OBJECT_FIELD_REF — directo por resource_type_id
        if (
          (field.frame_component_type === 'OBJECT_REFERENCE' ||
            field.frame_component_type === 'FIELD_REFERENCE' ||
            field.frame_component_type === 'OBJECT_FIELD_REF') &&
          field.resource_type_id === resource.id
        ) {
          return true;
        }

        // NESTED_TABLE — rastrear dentro de nested_table_columns
        if (
          field.frame_component_type === 'NESTED_TABLE' &&
          field.nested_table_columns && field.nested_table_columns.length
        ) {
          return field.nested_table_columns.some(function (col) {
            return col.resource_type_id === resource.id;
          });
        }

        return false;
      });
    });
  };

  $scope.isOwnerToggleLocked = function (owner) {
    if (!owner.enabled) return false;
    return $scope.resources.some(function (resource) {
      return resource.resource_owner &&
        resource.resource_owner.id === owner.id &&
        resource.enabled === true;
    });
  };

  $scope.viewAttributes = function (resource) {
    $mdDialog.show({
      controller: 'ResourceAttributesDialogController',
      templateUrl: 'template/resource-attributes-dialog-view.html',
      locals: { resource: angular.copy(resource), readOnly: true },
      parent: angular.element(document.body),
      clickOutsideToClose: true
    });
  };

  // ============================================
  // PENDING DELETES
  // ============================================

  $scope.pendingDeletes = { client: {}, resource: {}, owner: {}, frame: {} };

  $scope.confirmOrDelete = function (type, item, index, deleteFn) {
    var key = type === 'frame' ? item.frame_type_id : item.id;
    var pending = $scope.pendingDeletes[type];

    if (pending[key]) {
      deleteFn(key);          // ← pasa el ID, no el $index del filteredArray
      delete pending[key];
    } else {
      pending[key] = true;
      $timeout(function () { delete pending[key]; }, 4000);
    }
  };


  // ============================================
  // IMPORT RESOURCE TYPES
  // ============================================

  $scope.openImportResourcesDialog = function () {
    $mdDialog.show({
      controller: 'ImportResourcesTypesDialogController',
      templateUrl: 'template/importResourceTypes/import-resource-types-dialog.html',
      escapeToClose: false,
      parent: angular.element(document.body),
      clickOutsideToClose: true,
      multiple: true,
      locals: {
        templateData: $scope.resource_owners,
        template_id: $scope.editedTemplate.id,
        resource_types: $scope.resources
      }
    }).then(function (response) {
      if (!response || !response.data) return;

      var returnedTemplate = response.data;
      var returnedConfig = returnedTemplate.templateConfig;
      if (!returnedConfig) return;

      // ── 1. Detectar resource_types recién importados ─────────────────────────
      var existingResourceIds = new Set($scope.resources.map(function (r) { return r.id; }));

      var newResources = (returnedConfig.resource_types || []).filter(function (r) {
        return !existingResourceIds.has(r.id);
      });

      if (newResources.length === 0) {
        $mdToast.show($mdToast.simple()
          .textContent('⚠️ No new resources were imported')
          .position('top right').hideDelay(2500));
        return;
      }

      // ── 2. Agregar los nuevos resource_types al array en memoria ─────────────
      newResources.forEach(function (r) { $scope.resources.push(r); });
      $scope.editedTemplate.templateConfig.resource_types = $scope.resources;

      // ── 3. Agregar los attribute_types correspondientes ──────────────────────
      var newResourceIds = new Set(newResources.map(function (r) { return r.id; }));
      var existingAttrIds = new Set($scope.attributes.map(function (a) { return a.id; }));

      var newAttributes = (returnedConfig.attribute_types || []).filter(function (a) {
        return newResourceIds.has(a.resource_id) && !existingAttrIds.has(a.id);
      });

      newAttributes.forEach(function (a) { $scope.attributes.push(a); });
      $scope.editedTemplate.templateConfig.attribute_types = $scope.attributes;

      // ── 4. Reconstruir resource_owners y refrescar vistas ────────────────────
      $scope.reconstructResourceOwners();

      $scope.sortClientsBySortOrder();
      $scope.sortResourcesBySortOrder();
      $scope.sortOwnersBySortOrder();
      $scope.sortFrames();

      $scope.$applyAsync();

      $mdToast.show($mdToast.simple()
        .textContent('✅ ' + newResources.length + ' resource' + (newResources.length !== 1 ? 's' : '') + ' imported successfully')
        .position('top right').hideDelay(2500));

    }).catch(function () {
      console.log('Import dialog cancelled or closed without importing');
    });
  };

  // ============================================
  // MAP ENVIRONMENTS
  // ============================================

  $scope.mapEnvironments = function (resource, ev) {
    $mdDialog.show({
      controller: 'EnvironmentMappingsController',
      templateUrl: 'template/envMappings/env-mapping.html',
      parent: angular.element(document.body),
      targetEvent: ev,
      clickOutsideToClose: false,
      fullscreen: false,
      multiple: true,
      locals: {
        resource: angular.copy(resource),
        profile: $scope.profile,
        accountId: $scope.accountId,
        template: $scope.templateInstance
      }
    }).then(function (updatedResource) {
      if (!updatedResource) return;

      var index = $scope.editedTemplate.templateConfig.resource_types.findIndex(function (r) {
        return r.id === updatedResource.id;
      });

      if (index !== -1) {
        $scope.editedTemplate.templateConfig.resource_types[index].env_mappings = updatedResource.env_mappings;
        $scope.editedTemplate.templateConfig.resource_types[index].is_resource_imported = updatedResource.is_resource_imported;

        if (!updatedResource.is_resource_imported) {
          for (var i = $scope.attributes.length - 1; i >= 0; i--) {
            if ($scope.attributes[i].resource_id === updatedResource.id) {
              $scope.attributes[i].column_metadata_name = '';
            }
          }
        }

        $mdToast.show($mdToast.simple().textContent('Environment mappings updated successfully').position('top right').hideDelay(3000));
      }
    }).catch(function () {
      console.log('Environment mappings dialog cancelled');
    });
  };

  // ============================================
  // FRAME TYPES
  // ============================================

  $scope.selectedFrameIndex = null;

  $scope.selectFrame = function (index) {
    $scope.selectedFrameIndex = index;
  };


  $scope.editFrame = function (frame, $event) {
    if ($event) $event.stopPropagation();

    $mdDialog.show({
      controller: 'EditFrameDialogController',
      templateUrl: 'template/frameEdit/edit-frame-dialog.html',
      parent: angular.element(document.body),
      clickOutsideToClose: false,
      escapeToClose: false,
      multiple: true,
      locals: {
        frame: angular.copy(frame),
        template: $scope.editedTemplate
      }
    }).then(function (updatedFrame) {
      if (!updatedFrame) return;

      var index = $scope.frames.findIndex(function (f) {
        return f.frame_type_id === updatedFrame.frame_type_id;
      });

      if (index !== -1) {
        $scope.frames[index] = updatedFrame;
        $scope.sortFrames();
        $mdToast.show($mdToast.simple().textContent('Frame updated successfully').position('top right').hideDelay(2000));
      }
    }).catch(function () {
      console.log('Edit frame dialog cancelled');
    });
  };

  // Duplica el frame completo (campos, columnas anidadas, restricciones) con IDs nuevos:
  // biz-events referencian frame_type_id / frame_component_id, no pueden repetirse.
  $scope.copyFrame = function (frame, $event) {
    if ($event) $event.stopPropagation();

    var copy = angular.copy(frame);
    copy.frame_type_id = uuidv4();
    copy.frame_name = uniqueFrameName('COPY_OF_' + (frame.frame_name || ''));

    (copy.frame_fields || []).forEach(function (field) {
      field.frame_component_id = uuidv4();
      field.frame_type_id = copy.frame_type_id;
    });

    $scope.frames.push(copy);
    $scope.sortFrames();
    $scope.selectedFrameIndex = $scope.filteredFrames.findIndex(function (f) {
      return f.frame_type_id === copy.frame_type_id;
    });

    $timeout(function () {
      var input = document.getElementById('new-frame-name-' + copy.frame_type_id);
      if (input) {
        input.scrollIntoView({ behavior: 'smooth', block: 'center' });
        input.focus();
      }
    }, 80);

    $mdToast.show($mdToast.simple().textContent('Frame copied as ' + copy.frame_name).position('top right').hideDelay(2000));
  };

  function uniqueFrameName(baseName) {
    var taken = {};
    $scope.frames.forEach(function (f) { taken[f.frame_name] = true; });
    if (!taken[baseName]) return baseName;
    var n = 2;
    while (taken[baseName + '_' + n]) n++;
    return baseName + '_' + n;
  }

  $scope.removeFrame = function (frameTypeId) {
    var idx = $scope.frames.findIndex(function (f) {
      return f.frame_type_id === frameTypeId;
    });
    if (idx === -1) return;

    $scope.frames.splice(idx, 1);
    $scope.editedTemplate.templateConfig.frame_types = $scope.frames;
    $scope.selectedFrameIndex = null;
    $scope.sortFrames();
  };

  // ============================================
  // LINK DATASOURCE
  // ============================================

  $scope.linkDatasource = function (resource, $event) {
    if ($event) $event.stopPropagation();

    $mdDialog.show({
      controller: 'LinkDatasourceDialogController',
      templateUrl: '/template/linkDataSource/link-datasource-dialog.html',
      parent: angular.element(document.body),
      targetEvent: $event,
      clickOutsideToClose: false,
      fullscreen: false,
      multiple: true,
      locals: { resource: resource, template: $scope.editedTemplate }
    }).then(function (linkData) {
      if (!linkData) return;

      if (linkData.template) {
        if (linkData.template.templateConfig.resource_types) {
          $scope.resources = linkData.template.templateConfig.resource_types;
          $scope.editedTemplate.templateConfig.resource_types = $scope.resources;
        }
        if (linkData.template.templateConfig.attribute_types) {
          $scope.attributes = linkData.template.templateConfig.attribute_types;
          $scope.editedTemplate.templateConfig.attribute_types = $scope.attributes;
        }
        $scope.sortResourcesBySortOrder();

        var totalChanges = linkData.changes
          ? (linkData.changes.mappings?.length || 0) +
          (linkData.changes.modifiedAttributes?.length || 0) +
          (linkData.changes.createdAttributes?.length || 0)
          : 0;

        $mdToast.show($mdToast.simple()
          .textContent('✅ Resource linked with ' + totalChanges + ' change' + (totalChanges !== 1 ? 's' : ''))
          .position('top right').hideDelay(3000));

      } else if (linkData.datasource) {
        resource.is_resource_imported = true;
        resource.linked_datasource_id = linkData.datasource.id;
        resource.linked_datasource_name = linkData.datasource.name;
        resource.linked_schema = linkData.schema;
        resource.linked_table = linkData.table.tableName;
        $scope.sortResourcesBySortOrder();

        $mdToast.show($mdToast.simple()
          .textContent('✅ Resource linked to ' + linkData.table.tableName)
          .position('top right').hideDelay(3000));
      }

      $scope.$applyAsync();

    }, function () {
      console.log('❌ Link cancelled by user');
    });
  };

  // ============================================
  // DATASOURCE ONLINE STATUS MAP
  // Carga todos los datasources al abrir el dialog y construye
  // un mapa { datasourceId → isOnline } para consulta O(1).
  // ============================================

  $scope._datasourceOnlineMap = {};   // populated async

  DatasourceService.getDatasources($scope.editedTemplate.accountId)
    .then(function (datasources) {
      var map = {};
      (datasources || []).forEach(function (ds) {
        map[ds.id] = ds.isOnline === true;
      });
      $scope._datasourceOnlineMap = map;
      console.log('✅ Datasource online map loaded:', Object.keys(map).length, 'entries');
    })
    .catch(function (err) {
      console.warn('⚠️ Could not load datasource statuses — Edit Anchors will remain disabled.', err);
    });

  /**
   * Retorna true si el master env mapping del resource apunta a un datasource
   * que está ONLINE según el mapa cargado al inicio del dialog.
   */
  $scope.isMasterDatasourceOnline = function (resource) {
    if (!resource || !resource.env_mappings || !resource.env_mappings.length) return false;
    var master = resource.env_mappings.find(function (m) { return m.is_master === true; });
    if (!master || !master.datasource_id) return false;
    return $scope._datasourceOnlineMap[master.datasource_id] === true;
  };

  // ============================================
  // EDIT COLUMN MAPPINGS
  // ============================================

  $scope.editColumnMappings = function (resource, $event) {
    if ($event) $event.stopPropagation();

    if (!resource.env_mappings || resource.env_mappings.length === 0) {
      $mdToast.show($mdToast.simple()
        .textContent('⚠️ This resource has no environment mappings. Please map environments first.')
        .position('top right').hideDelay(3000).theme('warn'));
      return;
    }

    var masterMapping = resource.env_mappings.find(function (m) { return m.is_master === true; });

    if (!masterMapping) {
      $mdToast.show($mdToast.simple()
        .textContent('❌ No master environment found for this resource.')
        .position('top right').hideDelay(3000).theme('error'));
      return;
    }

    var attributesForResource = $scope.attributes.filter(function (attr) {
      return attr.resource_id === resource.id;
    });

    $mdDialog.show({
      controller: 'TableMapperDialogController',
      templateUrl: '/template/tableMapper/table-mapper-dialog.html',
      parent: angular.element(document.body),
      targetEvent: $event,
      clickOutsideToClose: false,
      escapeToClose: false,
      fullscreen: true,
      multiple: true,
      locals: {
        templateId: $scope.editedTemplate.id,
        resourceTypeId: resource.id,
        datasourceId: masterMapping.datasource_id,
        datasourceName: masterMapping.datasource_name,
        schema: masterMapping.schema_name,
        tableName: masterMapping.table_name,
        resource: angular.copy(resource),
        attributes: attributesForResource.map(function (a) { return angular.copy(a); }),
        templateInstance: angular.copy($scope.editedTemplate),
        mode: 'edit'
      }
    }).then(function (result) {
      if (!result) return;

      var newMappings = result.newMappings || [];
      var modifiedAttributes = result.modifiedAttributes || [];
      var createdAttributes = result.createdAttributes || [];
      var unmappedAttributes = result.unmappedAttributes || [];
      var mappings = result.mappings || [];

      // Desmapeados
      unmappedAttributes.forEach(function (attributeId) {
        var attr = $scope.attributes.find(function (a) { return a.id === attributeId; });
        if (attr) attr.column_metadata_name = null;
        var tAttr = ($scope.editedTemplate.templateConfig.attribute_types || []).find(function (a) { return a.id === attributeId; });
        if (tAttr) tAttr.column_metadata_name = null;
      });

      // Tipos modificados
      modifiedAttributes.forEach(function (modAttr) {
        var attr = $scope.attributes.find(function (a) { return a.id === modAttr.id; });
        if (attr) attr.scalar_attribute_type = modAttr.newType;
        var tAttr = ($scope.editedTemplate.templateConfig.attribute_types || []).find(function (a) { return a.id === modAttr.id; });
        if (tAttr) tAttr.scalar_attribute_type = modAttr.newType;
      });

      // Atributos creados
      createdAttributes.forEach(function (newAttr) {
        if ($scope.attributes.find(function (a) { return a.id === newAttr.id; })) return;
        $scope.attributes.push({
          id: newAttr.id,
          name: newAttr.name,
          enabled: true,
          description: newAttr.description || 'Imported from table column',
          resource_id: resource.id,
          scalar_attribute_type: newAttr.dataType,
          isPrimaryKey: newAttr.isPrimaryKey || false,
          isSensitive: false,
          isResourceNameField: false,
          isResourceDescriptionField: false,
          column_metadata_name: newAttr.columnMetadataName,
          enum_values: newAttr.enumValues || null
        });
      });

      // Nuevos mappings (edit mode)
      if (result.mode === 'edit') {
        newMappings.forEach(function (mapping) {
          if (mapping.isNewAttribute) return;
          var attr = $scope.attributes.find(function (a) { return a.id === mapping.attributeId; });
          if (attr) attr.column_metadata_name = mapping.columnName;
          var tAttr = ($scope.editedTemplate.templateConfig.attribute_types || []).find(function (a) { return a.id === mapping.attributeId; });
          if (tAttr) tAttr.column_metadata_name = mapping.columnName;
        });
      }

      // Todos los mappings (create mode)
      if (result.mode === 'create') {
        mappings.forEach(function (mapping) {
          var attr = $scope.attributes.find(function (a) { return a.id === mapping.attributeId; });
          if (attr) attr.column_metadata_name = mapping.columnName;
          var tAttr = ($scope.editedTemplate.templateConfig.attribute_types || []).find(function (a) { return a.id === mapping.attributeId; });
          if (tAttr) tAttr.column_metadata_name = mapping.columnName;
        });
      }

      $scope.templateModified = true;
      $scope.$applyAsync();

      var totalChanges = (result.mode === 'edit' ? newMappings.length : mappings.length) +
        modifiedAttributes.length + createdAttributes.length + unmappedAttributes.length;

      $mdToast.show($mdToast.simple()
        .textContent('✅ Column mappings updated: ' + totalChanges + ' change' + (totalChanges !== 1 ? 's' : '') + ' applied')
        .position('top right').hideDelay(3000).theme('success'));

    }).catch(function (error) {
      if (error) console.error('Error details:', error);
    });
  };

  // ============================================
  // CLEANUP
  // ============================================

  $scope.$on('$destroy', function () {
    $scope.validationError = null;
    $scope.showValidationBanner = false;
    $scope.pendingDeletes = { client: {}, resource: {}, owner: {}, frame: {} };
    if ($scope.validationTimeout) clearTimeout($scope.validationTimeout);
    $scope.saving = false;
    $scope.templateModified = false;
  });

  $scope.addFrame = function () {
    var newFrame = {
      frame_type_id: uuidv4(),
      frame_name: '',
      frame_description: '',
      enabled: true
    };
    $scope.frames.push(newFrame);
    $scope.applyFrameFilter();
    $scope.selectedFrameIndex = $scope.filteredFrames.length - 1;
    $timeout(function () {
      var input = document.getElementById('new-frame-name-' + newFrame.frame_type_id);
      if (input) input.focus();
    }, 80);
  };

  // Unsaved-change tracking needs no call here: hasFramesChanged() compares
  // frames against originalFrames. Spaces become underscores as they are typed.
  $scope.onFrameNameChange = function (frame) {
    if (frame.frame_name) {
      frame.frame_name = frame.frame_name.toUpperCase().replace(/\s/g, '_');
    }
  };

  $scope.frameNameIsDuplicate = function (frame) {
    if (!frame.frame_name || frame.frame_name.trim() === '') return false;
    return ($scope.frames || []).filter(function (f) {
      return f.frame_name === frame.frame_name;
    }).length > 1;
  };

  $scope.hasFrameNameConflict = function () {
    var seen = {};
    return ($scope.frames || []).some(function (f) {
      if (!f.frame_name || f.frame_name.trim() === '') return false;
      if (seen[f.frame_name]) return true;
      seen[f.frame_name] = true;
      return false;
    });
  };

});